import React from 'react';
import CustomerFurniture from 'components/Tvendo/BusinessPartner/DataMaster/CustomerFurniture/List.js';

export default function () {
  return <CustomerFurniture />;
}
